import React from 'react';
import Close from './Close';
import SuccessFilled from './SuccessFilled';
import ToastError from './ToastError';
import Backward from './Backward';
import Forward from './Forward';
import Copy from './Copy';
import Loader from './Loader';
import EditorLoader from './EditorLoader';
import AIInputSend from './AIInputSend';
import AIInputLogo from './AIInputLogo';
import ArrowRight from './ArrowRight';
import AIIcon from './AIIcon';
import Star from './Star';
import Broom from './Broom';
import Download from './Download';
import Unlock from './Unlock';
import Atom from './Atom';
import Book from './Book';
import BookPen from './BookPen';
import Brain from './Brain';
import Calculator from './Calculator';
import Calendar from './Calendar';
import Checklist from './Checklist';
import ChecklistNote from './ChecklistNote';
import ChecklistPen from './ChecklistPen';
import ChecklistSucDec from './ChecklistSucDec';
import Convo from './Convo';
import CrossPlus from './CrossPlus';
import Darts from './Darts';
import Diagram from './Diagram';
import Document from './Document';
import Documents from './Documents';
import Graph from './Graph';
import Hat from './Hat';
import Idea from './Idea';
import MedDoc from './MedDoc';
import MultiNotes from './MultiNotes';
import NoteGraph from './NoteGraph';
import NoteList from './NoteList';
import NoteSuc from './NoteSuc';
import NoteText from './NoteText';
import NoteWithPen from './NoteWithPen';
import Notes from './Notes';
import Paint from './Paint';
import Pens from './Pens';
import PersonPlus from './PersonPlus';
import Puzzle from './Puzzle';
import Question from './Question';
import Questions from './Questions';
import Quote from './Quote';
import Scale from './Scale';
import ScaleIdea from './ScaleIdea';
import Setting from './Setting';
import Stonks from './Stonks';
import Tab from './Tab';
import Tasks from './Tasks';
import Time from './Time';
import Tree from './Tree';

export enum IconGlyph {
  CLOSE = 'close',
  SUCCESS_FILLED = 'success_filled',
  TOAST_ERROR = 'toast_error',
  BACKWARD = 'backward',
  FORWARD = 'forward',
  COPY = 'copy',
  DOWNLOAD = 'download',
  LOADER = 'loader',
  EDITOR_LOADER = 'editor_loader',
  AI_INPUT_SEND = 'ai_input_send',
  AI_INPUT_LOGO = 'ai_input_logo',
  ARROW_RIGHT = 'arrow_right',
  AI_ICON = 'ai_icon',
  STAR = 'star',
  BROOM = 'broom',
  UNLOCK = 'unlock',
  ATOM = 'atom',
  BOOK = 'book',
  BOOK_PEN = 'book_pen',
  BRAIN = 'brain',
  CALCULATOR = 'calculator',
  CALENDAR = 'calendar',
  CHECKLIST = 'checklist',
  CHECKLIST_NOTE = 'checklist_note',
  CHECKLIST_PEN = 'checklist_pen',
  CHECKLIST_SUC_DEC = 'checklist_suc_dec',
  CONVO = 'convo',
  CROSS_PLUS = 'cross_plus',
  DARTS = 'darts',
  DIAGRAM = 'diagram',
  DOCUMENT = 'document',
  DOCUMENTS = 'documents',
  GRAPH = 'graph',
  HAT = 'hat',
  IDEA = 'idea',
  MED_DOC = 'med_doc',
  MULTI_NOTES = 'multi_notes',
  NOTE_GRAPH = 'note_graph',
  NOTE_LIST = 'note_list',
  NOTE_SUC = 'note_suc',
  NOTE_TEXT = 'note_text',
  NOTE_WITH_PEN = 'note_with_pen',
  NOTES = 'notes',
  PAINT = 'paint',
  PENS = 'pens',
  PERSON_PLUS = 'person_plus',
  PUZZLE = 'puzzle',
  QUESTION = 'question',
  QUESTIONS = 'questions',
  QUOTE = 'quote',
  SCALE = 'scale',
  SCALE_IDEA = 'scale_idea',
  SETTING = 'setting',
  STONKS = 'stonks',
  TAB = 'tab',
  TASKS = 'tasks',
  TIME = 'time',
  TREE = 'tree',
}

const icons = {
  [IconGlyph.CLOSE]: Close,
  [IconGlyph.SUCCESS_FILLED]: SuccessFilled,
  [IconGlyph.TOAST_ERROR]: ToastError,
  [IconGlyph.BACKWARD]: Backward,
  [IconGlyph.FORWARD]: Forward,
  [IconGlyph.COPY]: Copy,
  [IconGlyph.DOWNLOAD]: Download,
  [IconGlyph.LOADER]: Loader,
  [IconGlyph.EDITOR_LOADER]: EditorLoader,
  [IconGlyph.AI_INPUT_SEND]: AIInputSend,
  [IconGlyph.AI_INPUT_LOGO]: AIInputLogo,
  [IconGlyph.ARROW_RIGHT]: ArrowRight,
  [IconGlyph.AI_ICON]: AIIcon,
  [IconGlyph.STAR]: Star,
  [IconGlyph.BROOM]: Broom,
  [IconGlyph.UNLOCK]: Unlock,
  [IconGlyph.ATOM]: Atom,
  [IconGlyph.BOOK]: Book,
  [IconGlyph.BOOK_PEN]: BookPen,
  [IconGlyph.BRAIN]: Brain,
  [IconGlyph.CALCULATOR]: Calculator,
  [IconGlyph.CALENDAR]: Calendar,
  [IconGlyph.CHECKLIST]: Checklist,
  [IconGlyph.CHECKLIST_NOTE]: ChecklistNote,
  [IconGlyph.CHECKLIST_PEN]: ChecklistPen,
  [IconGlyph.CHECKLIST_SUC_DEC]: ChecklistSucDec,
  [IconGlyph.CONVO]: Convo,
  [IconGlyph.CROSS_PLUS]: CrossPlus,
  [IconGlyph.DARTS]: Darts,
  [IconGlyph.DIAGRAM]: Diagram,
  [IconGlyph.DOCUMENT]: Document,
  [IconGlyph.DOCUMENTS]: Documents,
  [IconGlyph.GRAPH]: Graph,
  [IconGlyph.HAT]: Hat,
  [IconGlyph.IDEA]: Idea,
  [IconGlyph.MED_DOC]: MedDoc,
  [IconGlyph.MULTI_NOTES]: MultiNotes,
  [IconGlyph.NOTE_GRAPH]: NoteGraph,
  [IconGlyph.NOTE_LIST]: NoteList,
  [IconGlyph.NOTE_SUC]: NoteSuc,
  [IconGlyph.NOTE_TEXT]: NoteText,
  [IconGlyph.NOTE_WITH_PEN]: NoteWithPen,
  [IconGlyph.NOTES]: Notes,
  [IconGlyph.PAINT]: Paint,
  [IconGlyph.PENS]: Pens,
  [IconGlyph.PERSON_PLUS]: PersonPlus,
  [IconGlyph.PUZZLE]: Puzzle,
  [IconGlyph.QUESTION]: Question,
  [IconGlyph.QUESTIONS]: Questions,
  [IconGlyph.QUOTE]: Quote,
  [IconGlyph.SCALE]: Scale,
  [IconGlyph.SCALE_IDEA]: ScaleIdea,
  [IconGlyph.SETTING]: Setting,
  [IconGlyph.STONKS]: Stonks,
  [IconGlyph.TAB]: Tab,
  [IconGlyph.TASKS]: Tasks,
  [IconGlyph.TIME]: Time,
  [IconGlyph.TREE]: Tree,
};

interface Props {
  size?: number;
  glyph: IconGlyph;
  strokeWidth?: number;
}

const Icon: React.FC<Props> = ({ glyph, ...restProps }) => {
  const Component = icons[glyph];
  return <Component {...restProps} />;
};

export default Icon;
